import { Wrench } from "lucide-react";
import { useI18n } from "../lib/i18n";

export const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-zinc-900 py-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="w-8 h-8 bg-[#E51E1A] flex items-center justify-center">
            <Wrench className="w-4 h-4 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-headings uppercase text-white tracking-wide">
            Torque Latino Mobile
          </span>
        </div>
        <div className="font-condensed uppercase text-xs tracking-[0.3em] text-zinc-500 text-center">
          {t.footer.tagline}
        </div>
        <div className="font-condensed uppercase text-xs tracking-[0.3em] text-zinc-600">
          © {year} · {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};
